<template>
  <span class="flex items-center" :tooltip="tooltipText" :position="position"><slot /></span>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "my-tooltip",
  props: {
    tooltipText: {
      type: String,
      default: "Tooltip text",
    },
    position: {
      default: "top",
      type: String,
    },
  },
});
</script>
<style>
@import "./Tooltip.css";
</style>